import type { GetServerSidePropsContext, InferGetServerSidePropsType, NextPage } from 'next';
import { Fragment } from 'react';

import { getSiteUrl } from 'lib/utils/Environment';
import GetFreeQuotes from 'pages/oneflare.com.au/GetFreeQuotes/GetFreeQuotes';
import HeadContent from 'shared/components/_oneflare/HeadContent/HeadContent';

const SITE_URL = getSiteUrl();

const GetFreeQuotesPage: NextPage = (props: InferGetServerSidePropsType<typeof getServerSideProps>) => (
  <Fragment>
    <HeadContent
      pageUrl={`${SITE_URL}/get-free-quotes`}
      pageTitle="Get Free Quotes | Oneflare"
      metaNoIndex
    />
    <GetFreeQuotes {...props} />
  </Fragment>
);

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const originalReferer = ctx.req.headers.referer ?? `${ctx.req.headers.host}${ctx.req.url.replace(/\?.*/, '')}`;
  const isIframe = ctx.req.headers['sec-fetch-dest'] === 'iframe';

  if (!isIframe) {
    return {
      redirect: {
        destination: `${SITE_URL}/`,
        permanent: false
      }
    };
  }

  return {
    props: {
      isIframe,
      originalReferer
    }
  };
}

export default GetFreeQuotesPage;
